import React, { useEffect, useState } from "react";
import { School, BellRing, BellOff } from "lucide-react";
import { api } from "@/lib/api";

export const fmtSeen = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export default function SchoolPushList({ open }) {
  const [data, setData] = useState(null);
  const [showPending, setShowPending] = useState(false);
  useEffect(() => {
    if (open) {
      api.get("/admin/push/schools").then((r) => setData(r.data)).catch(() => setData({ active: [], pending: [] }));
    }
  }, [open]);
  if (!data) return null;
  return (
    <div className="space-y-2" data-testid="notif-schools-section">
      <p className="text-[11px] font-black uppercase text-slate-500 tracking-widest">
        Escolas com notificação ativa ({data.active.length})
      </p>
      {data.active.length === 0 ? (
        <p className="text-[12px] text-slate-400 italic" data-testid="notif-schools-empty">Nenhuma escola ativou as notificações ainda.</p>
      ) : (
        <ul className="divide-y divide-slate-100 border border-slate-100 rounded-lg max-h-52 overflow-y-auto">
          {data.active.map((s) => (
            <li key={s.school_id} className="px-3 py-2 flex items-start gap-2 text-[12px]" data-testid={`notif-school-${s.school_id}`}>
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-[#1e3a8a] text-white shrink-0"><School className="w-3 h-3" /></span>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-slate-800 truncate">{s.name}</p>
                {s.devices.map((d) => (
                  <p key={d.endpoint} className="text-[10.5px] text-slate-500 truncate flex items-center gap-1">
                    <BellRing className="w-3 h-3 text-emerald-600 shrink-0" />
                    {d.label}{d.env ? ` · ${d.env}` : ""}{fmtSeen(d.updated_at) ? ` · ${fmtSeen(d.updated_at)}` : ""}
                  </p>
                ))}
              </div>
            </li>
          ))}
        </ul>
      )}
      {data.pending.length > 0 && (
        <div>
          <button type="button" onClick={() => setShowPending((v) => !v)} className="text-[11px] font-bold text-amber-700 hover:underline" data-testid="notif-schools-pending-toggle">
            {showPending ? "Ocultar" : "Ver"} escolas que ainda não ativaram ({data.pending.length})
          </button>
          {showPending && (
            <ul className="mt-1.5 border border-amber-100 bg-amber-50/50 rounded-lg divide-y divide-amber-100 max-h-40 overflow-y-auto" data-testid="notif-schools-pending">
              {data.pending.map((s) => (
                <li key={s.school_id} className="px-3 py-1.5 text-[11.5px] text-slate-700 flex items-center gap-1.5">
                  <BellOff className="w-3 h-3 text-amber-600 shrink-0" />{s.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
